module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/printer-258c6a75d120bebaf93b390c0725709b.svg";